import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography as MuiTypography,
  List,
  ListItem,
} from "@mui/material";
import { spacing } from "@mui/system";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Typography = styled(MuiTypography)(spacing);

function PoliciesAndProcedures() {
  return (
    <React.Fragment>
      <Helmet title="Policies and Procedures" />

      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} lg={9} xl={7}>
          <Typography variant="h2" gutterBottom display="inline">
            Notice of Patient Rights Policy
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            <Link component={NavLink} to="/documentation/policies-and-procedures">
              Policies And Procedures
            </Link>
            <Typography>Notice of Patient Rights Policy</Typography>
          </Breadcrumbs>

          <Divider my={6} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default PoliciesAndProcedures;
